export function formatCompactNumber(input: string | undefined): string {
	if (!input) return '0';

	const num = parseFloat(input);
	if (isNaN(num)) return 'NaN';

	const format = (value: number, suffix: string) => {
		const rounded = +value.toFixed(1);
		return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded}${suffix}`;
	};

	if (num >= 1_000_000_000) {
		return format(num / 1_000_000_000, 'B');
	} else if (num >= 1_000_000) {
		return format(num / 1_000_000, 'M');
	} else if (num >= 1_000) {
		return format(num / 1_000, 'k');
	} else {
		return num.toString();
	}
}
